import type { TaskResult } from "../types";
// v2 - fecha detection fix
export async function gradeProject17(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Verificar que el rango nombrado EncabezadoApp2 esté vacío
  try {
    await Excel.run(async (context) => {
      const named = context.workbook.names.getItem("EncabezadoApp2").getRange();
      named.load("values");
      await context.sync();

      const blank = named.values.flat().every((value) => String(value ?? "") === "");
      console.log("[T1] values:", JSON.stringify(named.values), "blank:", blank);
      results.push({ taskId: 1, passed: blank });
    });
  } catch (e) {
    console.error("[T1] ERROR:", e);
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Verificar altura de fila 27 = 78
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Descargas");
      const row = sheet.getRange("27:27");
      row.format.load("rowHeight");
      await context.sync();

      console.log("[T2] rowHeight:", row.format.rowHeight);
      results.push({ taskId: 2, passed: Number(row.format.rowHeight) === 78 });
    });
  } catch (e) {
    console.error("[T2] ERROR:", e);
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Verificar estilo de celda "40% - Accent2" en A27
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Descargas");
      const cell = sheet.getRange("A27");
      cell.load("style");
      await context.sync();

      const style = String(cell.style).toUpperCase().replace(/\s+/g, "");
      const has40 = style.includes("40%");
      const hasAccent2 = style.includes("ACCENT2") || style.includes("NFASIS2");
      console.log("[T3] style:", cell.style, "normalized:", style, "has40:", has40, "hasAccent2:", hasAccent2);
      results.push({
        taskId: 3,
        passed: has40 && hasAccent2,
      });
    });
  } catch (e) {
    console.error("[T3] ERROR:", e);
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Verificar tabla en A3:B24 con estilo claro 10
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Descargas");
      const tables = sheet.tables;
      tables.load("items");
      await context.sync();

      let passed = false;
      console.log("[T4] tables count:", tables.items.length);
      if (tables.items.length > 0) {
        const table = tables.items[0];
        table.load("style");
        const range = table.getRange();
        range.load("address");
        await context.sync();

        const address = String(range.address).replace(/\$/g, "").toUpperCase();
        passed =
          address.includes("A3:B24") &&
          String(table.style).toUpperCase().includes("LIGHT10");
        console.log("[T4] address:", address, "style:", table.style, "passed:", passed);
      }

      results.push({ taskId: 4, passed });
    });
  } catch (e) {
    console.error("[T4] ERROR:", e);
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Verificar pie de página con fecha en cualquier sección
  // Office.js codifica las secciones con &L, &C, &R internamente
  // y &D = fecha. El contenido puede aparecer en cualquier propiedad.
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Descargas");
      const defaultHF = sheet.pageLayout.headersFooters.defaultForAllPages;
      defaultHF.load("rightFooter,centerFooter,leftFooter");
      await context.sync();

      const all = [
        defaultHF.rightFooter,
        defaultHF.centerFooter,
        defaultHF.leftFooter,
      ];
      // Debug: ver exactamente qué contiene cada sección
      console.log("[T5] right:", JSON.stringify(defaultHF.rightFooter));
      console.log("[T5] center:", JSON.stringify(defaultHF.centerFooter));
      console.log("[T5] left:", JSON.stringify(defaultHF.leftFooter));

      // En Excel español: &F = Fecha, &D = Derecha (marcador de sección)
      const hasDate = all.some((f) => {
        const text = String(f ?? "");
        return text.includes("&F");
      });
      console.log("[T5] hasDate:", hasDate);
      results.push({ taskId: 5, passed: hasDate });
    });
  } catch (e) {
    console.error("[T5] ERROR:", e);
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
